import { render, staticRenderFns } from "./BoxIcon.vue?vue&type=template&id=7e0e900e&scoped=true"
import script from "./BoxIcon.vue?vue&type=script&lang=js"
export * from "./BoxIcon.vue?vue&type=script&lang=js"
import style0 from "./BoxIcon.vue?vue&type=style&index=0&id=7e0e900e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e0e900e",
  null
  
)

export default component.exports